module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumb/Chernobyl-S1.9db594b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumb/Chernobyl-S1.jpg
// module id = 2nfL
// module chunks = 0